module.exports = __webpack_public_path__ + "static/media/dhahabsports.4668605d.png";